import { Box, MenuItem as MuiMenuItem, styled, Select as MuiSelect, SelectProps as MuiSelectProps } from '@mui/material'
import Image, { ImageProps } from 'next/image'
import React, { ReactNode } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const Tag = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 2px 4px;

  background: rgba(191, 255, 11, 0.1);
  border-radius: 4px;

  margin-right: 4px;

  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  font-feature-settings: 'ss01' on, 'case' on, 'calt' off;
`

export const MenuItem = styled(MuiMenuItem)`
  width: 100%;
  height: 60px;
`

export interface SelectProps<T = unknown> extends MuiSelectProps<T> {
  tag?: string
  renderIcon?: (value: T) => ReactNode
  renderLabel?: (value: T) => ReactNode
  renderEmpty?: (value: T) => ReactNode
}

export const Icon = (props: ImageProps) => {
  if (!props.src) return null
  return <Image src={props.src} style={{ borderRadius: '50%' }} width={24} height={24} alt={props.alt} />
}

const Select: <T>(props: SelectProps<T>) => JSX.Element = ({
  children,
  readOnly,
  tag,
  renderIcon,
  renderLabel,
  renderEmpty,
  ...restProps
}: SelectProps) => {
  return (
    <MuiSelect
      fullWidth
      {...restProps}
      readOnly={readOnly}
      IconComponent={ExpandMoreIcon}
      inputProps={{ sx: { py: 18, px: 20 } }}
      MenuProps={{
        MenuListProps: { sx: { py: 0, maxHeight: 300 } },
        PaperProps: { sx: { backgroundImage: 'none', borderRadius: 'unset', border: '1px solid #bfff0b' } },
      }}
      renderValue={(value) => {
        if (value === '') {
          return renderEmpty ? renderEmpty(value) : null
        }
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {tag ? <Tag>{tag}</Tag> : null}
            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 8 }}>
              {renderIcon ? renderIcon(value) : null}
              {renderLabel ? renderLabel(value) : String(value)}
            </Box>
          </Box>
        )
      }}
    >
      {children}
    </MuiSelect>
  )
}

export default Select
